<template>
	<!-- <div class="modal">
		<div id="questions" class="modal fade" role="dialog">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Tip</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body project-task">
                    	Hello {{name}}
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-warning" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
	</div> -->
</template>

<script>
	export default{
		name: 'Tips',
		props:{
			message: ''
		},
		mounted(){
			this.$swal.fire({
				title: '<u>Tip</u>',
				text: this.message,
				footer: '<input type="checkbox" />&nbsp;<h6>Don\'t show tips again. You can turn this back on in settings.</h6>',
				timer: 3000,
				showConfirmButton: false,
				width: '700px'
			})
		}
	}
</script>